import { EXPRESS_API } from 'configs/api/expressApi';
import { successToast } from 'lib/components/toasts/success';
import { useToastError } from 'lib/hooks';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { spotlightKeys } from './spotlightKeys';

export interface ICreateSpotlightParams {
  script: string;
  backgroundId: string;
}

export interface ICreateSpotlightResponse {
  videoId: number;
}

export const createSpotlight = async (
  params: ICreateSpotlightParams
): Promise<ICreateSpotlightResponse> => {
  const response = await EXPRESS_API.post('/quick-videos/spotlight', params);
  return response.data;
};

export const useCreateSpotlightMutation = (
  onSuccess?: (uploadedVideoId: number) => void
) => {
  const { showError } = useToastError();
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useMutation(createSpotlight, {
    onSuccess: async res => {
      await queryClient.invalidateQueries(spotlightKeys.all());
      onSuccess?.(res.videoId);
      successToast({
        title: t(`Flex Video has been successfully created!`),
      });
    },
    onError: error =>
      showError(
        error || t(`An error occurred while trying to create the spotlight.`)
      ),
  });
};
